import React from "react";
import CodeTabBlock from "./CodeTabBlock";

const CodeTabsWleEmbedUrl = () => {
  const tabName = "WleEmbedUrl";
  const tabContent = {
    Python: `
    import hmac
    import hashlib
    import base64
    
    def sign_url(url, key, secret, timestamp):
        request_type = 'GET'
        content_type = ''
        content_digest = hashlib.md5().digest()
        content_digest = base64.encodebytes(content_digest).decode('utf-8').strip()
         
        request_string = ','.join([request_type, content_type, content_digest, url, str(timestamp)])
    
        secret_bytes = bytearray(secret, encoding='utf-8')
        request_bytes = bytearray(request_string, encoding='utf-8')
    
        signature = hmac.new(secret_bytes, msg=request_bytes, digestmod=hashlib.sha256).hexdigest()
    
        signed_url = '%s&signature=%s' % (url, signature)
        return signed_url
    
    sign_url(request_url, access_key, access_secret, timestamp)
    `,
    JavaScript: `
    const crypto = require('crypto');

    function signUrl(url, key, secret, timestamp) {
        var requestType = 'GET';
        var contentType = null;
        var contentBody = '';
        var contentDigest = crypto.createHash('md5').update(contentBody).digest().toString('base64');

        var requestString = [requestType, contentType, contentDigest, url, timestamp].join(',');

        var signature = crypto.createHmac('sha256', secret).update(requestString).digest('hex');

        var signedUrl = url + '&signature=' + signature;
        return signedUrl
    }
    signUrl(request_url, access_key, access_secret, timestamp);
    `,
    Ruby: `
    require 'digest'
    require 'openssl'
    
    def sign_url(url, key, secret, timestamp)
      request_type = 'GET'
      content_type = nil
      content_body = ''
      content_digest = Digest::MD5.base64digest(request_body)
    
      request_string = [request_type, content_type, content_digest, url, timestamp].join(',')
    
      digest = OpenSSL::Digest.new('sha256')
      signature = OpenSSL::HMAC.hexdigest(digest, secret, request_string)
    
      signed_url = "#{url}&signature=#{signature}"
      signed_url
    end
    
    sign_url(request_url, access_key, access_secret, timestamp)
    `,
    PHP: `
    function signUrl($url, $key, $secret, $timestamp) {
      $request_type = 'GET';
      $content_type = '';
      $content_body = '';
      $content_digest = base64_encode(pack('H*', md5($content_body)));
  
      $request_array = array($request_type, $content_type, $content_digest, $url, $timestamp);
      $request_string = implode(',', $request_array);
  
      $signature = hash_hmac('sha256', $request_string, $secret, false);
  
      $signed_url = "{$url}&signature={$signature}";
      return $signed_url;
  }
  
  > echo signUrl($request_url, $access_key, $access_secret, $timestamp);
    `
  };
  return (
    <CodeTabBlock  tabName={tabName} tabContent={tabContent}/>
  );
};

export default CodeTabsWleEmbedUrl;
